import React from 'react';

import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import PublicIcon from '@material-ui/icons/PublicOutlined';
import PersonIcon from '@material-ui/icons/PersonOutline';
import FavoriteIcon from '@material-ui/icons/FavoriteBorderOutlined';
import BookmarkIcon from '@material-ui/icons/BookmarkBorderOutlined';
import MailIcon from '@material-ui/icons/MailOutline';
import StarIcon from '@material-ui/icons/StarBorderOutlined';

import * as routes from '../../config/routes';
import classes from '../../css/getCSS';

const dashNav = (props) => {
  let linkNav = null

  if (props.user.state === 1){
    linkNav = (
        <React.Fragment>
            <Link
                to={formatRoute(routes.ACTIVITIES, { type: 'interests' })}
                className={classes.listItemLink}
            >
                <ListItem button selected={props.dashActiveLink === 'interests'} onClick={props.closeDialog}>
                    <ListItemIcon>
                        <FavoriteIcon />
                    </ListItemIcon>
                    <ListItemText primary="Interests" />
                </ListItem>
            </Link>
            <Link
                to={formatRoute(routes.ACTIVITIES, { type: 'shortlists' })}
                className={classes.listItemLink}
            >
                <ListItem button selected={props.dashActiveLink === 'shortlists'} onClick={props.closeDialog}>
                    <ListItemIcon>
                        <BookmarkIcon />
                    </ListItemIcon>
                    <ListItemText primary="Shortlists" />
                </ListItem>
            </Link>
            <Link
                to={formatRoute(routes.ACTIVITIES, { type: 'recommendations' })}
                className={classes.listItemLink}
            >
                <ListItem button selected={props.dashActiveLink === 'recommendations'} onClick={props.closeDialog}>
                    <ListItemIcon>
                        <StarIcon />
                    </ListItemIcon>
                    <ListItemText primary="Recommendations" />
                </ListItem>
            </Link>
            <Link
                to={formatRoute(routes.ACTIVITIES, { type: 'messages' })}
                className={classes.listItemLink}
            >
                <ListItem button selected={props.dashActiveLink === 'messages'} onClick={props.closeDialog}>
                    <ListItemIcon>
                        <MailIcon />
                    </ListItemIcon>
                    <ListItemText primary="Messages" />
                </ListItem>
            </Link>
        </React.Fragment>
    )
  }
  return (
    <React.Fragment>
      { console.log('dashNav===props===', props) }
      <List>
        <Link to="/" className={classes.listItemLink}>
          <ListItem button selected={props.dashActiveLink === 'feed'}>
            <ListItemIcon>
              <PublicIcon />
            </ListItemIcon>
            <ListItemText primary="My Activity Feed" />
          </ListItem>
        </Link>
        <Link
          to={formatRoute(routes.VIEW_PROFILE, { uuid: props.user.slug })}
          className={classes.listItemLink}
        >
          <ListItem button selected={props.dashActiveLink === 'profile'}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="My Profile" />
          </ListItem>
        </Link>
          {linkNav}
      </List>
    </React.Fragment>
  );
};


export default dashNav;



// WEBPACK FOOTER //
// ./src/dashboard/components/DashNav.js